var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-view"},[_c('ul',_vm._l((_vm.menuList),function(item,index){return _c('li',{key:index},[_c('router-link',{class:_vm.activeNum === index ? 'isActive' : '',attrs:{"to":item.path}},[_vm._v(_vm._s(item.text))])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-e2713652","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/base/menu/menu.vue
// module id = null
// module chunks = 